import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort ,  DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import * as moment from 'moment';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../models/messages';
import { FiltrosDnSubasta } from 'app/models/FiltrosDnSubasta';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
    selector: 'app-listado-dnsubasta',
    templateUrl: './listado-dnsubasta.component.html',
    styleUrls: ['./listado-dnsubasta.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class ListadoDnSubastaComponent implements OnInit{
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  DTOFiltrosDnSubasta: FiltrosDnSubasta = new FiltrosDnSubasta();
  monedaElement:any;
  idAdquirente ="";
  rucAdq = new FormControl('');
  DocumentosNegociables:any = [];
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  filteredAdquirente: Observable<any[]>;
  adquirentesArr;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','Adq_Razon_Social','Adq_Ruc','Fecha_Registro','Moneda_Dsc','VNPP_Subasta','Fecha_de_Pago','Motivo'];
  dataSource :any; 
  constructor(private datepipe:DatePipe,private documentoNegociable:DocumentoNegociableService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus){
    this.DTOFiltrosDnSubasta.FechaIni = this.datepipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosDnSubasta.FechaFin = this.datepipe.transform(moment(),'yyyy-MM-dd');
   }

  ngOnInit(){
    this.DTOFiltrosDnSubasta.Moneda = this.Label_id_soles;
    this.monedaElement = this.Label_id_soles;
    this.ListadoDnSubasta();
        
  }

  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosDnSubasta.Moneda=0;
    }else{
      this.DTOFiltrosDnSubasta.Moneda = event;
    }      
  }

  obtenerRucRazSocialAdq(termino :string = ''){  
    if (termino != null && termino != ''){      
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){         
            this.idAdquirente = p.idEmpresa;
            this.DTOFiltrosDnSubasta.IdAdq = p.idEmpresa;
          }
      }
    }
  }

  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirente = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentesArr.slice()
      )
    ); 
  }

private _filterAdq(value: string): any[] {
  const filterValue = value.toString().toLowerCase();
  return this.adquirentesArr.filter(
    state => state.Razon_Social.toLowerCase().includes(filterValue) === true
  );
}

obtenerIdAdq(termino :string){
  this.idAdquirente = termino;
   this.DTOFiltrosDnSubasta.IdAdq = termino;
}



ListadoDnSubasta(){
  this.loading = true;

if (this.rucAdq.value == null || this.rucAdq.value == ""){
  this.idAdquirente = "0";
  this.DTOFiltrosDnSubasta.IdAdq = "0";
}
  this.DTOFiltrosDnSubasta.FechaIni = this.datepipe.transform(this.DTOFiltrosDnSubasta.FechaIni,'yyyy-MM-dd')
  this.DTOFiltrosDnSubasta.FechaFin = this.datepipe.transform(this.DTOFiltrosDnSubasta.FechaFin,'yyyy-MM-dd')
this.documentoNegociable.obtenerDocumentosSubasta(this.DTOFiltrosDnSubasta)
.subscribe( resp => { 

  this.DocumentosNegociables= resp
  this.dataSource = new MatTableDataSource( this.DocumentosNegociables);
  this.dataSource.sort = this.sort;
  this.dataSource.paginator = this.paginator;
  this.loading = false;
 
 
}, (err)=> {
  this.loading = false;
  if (err.error instanceof ErrorEvent) {
    console.error("Error Event");
} else {
    this.msgStatus.getMessage(err.status);            
}
Swal.fire({
  title: this.msgTitulos.Error,
  text: "LISTA NO OBTENIDA. "+this.msgStatus.message,
  type: "error",
  allowOutsideClick: false,
  heightAuto: false
});
})  
}
}
